module.exports = __webpack_public_path__ + "media/CN_002.5be43274.mp3";